export default {"src":"/_next/static/media/manage-account.fb20b933.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};